import { Form } from "antd";
import TextArea from "antd/es/input/TextArea";

type TextType = {
  name?: string;
  className?: string;
  step?: string;
  isRequired?: boolean;
  placeholder?: string;
  pattern?: string;
  disabled?: boolean;
  errorMessage?: string;
  type?: string;
  formItemClassName?: string;
  label?: string;
  optional?: boolean;
  maxLength?: number;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export const TextAreaField: React.FC<TextType> = ({
  name,
  className,
  formItemClassName,
  isRequired,
  placeholder,
  errorMessage,
  label,
  optional,
  maxLength,
  onChange,
}) => {
  return (
    <Form.Item
      name={name}
      label={label}
      className={`${formItemClassName} relative ${optional && "show-optional"}`}
      rules={[{ required: isRequired, message: errorMessage }]}
    >
      <TextArea
        maxLength={maxLength}
        className={`${className} ${
          optional && "pr-20"
        } w-full pt-2 placeholder:text-[#818181] px-[22px] rounded-xl !border-white/10 focus:border-white text-white`}
        placeholder={placeholder}
        onChange={onChange}
      />
    </Form.Item>
  );
};
